


const STUDY_FORMS = {
    "1": {
        id: "insights_study_crf_v1",
        title: "INSIGHTS Study - Type 2 Diabetes Mellitus Case Report Form",
        sections: [
            {
                id:"section_0_consent",
                order:0,
                title:"Informed Consent",
                subsections:[
                    {
                        id:"informed_consent_details",
                        fields:[
                            {
                                id:"consent_obtained",
                                type:"radio",
                                label:"Was informed consent obtained?",
                                options:["YES","NO"],
                                required:true
                            },
                            {
                                id:"consent_date",
                                type:"date",
                                label:"Consent Date",
                                showIf:{
                                    field:"consent_obtained",
                                    value:"YES"
                                },
                                required:true,
                                format:"dd-MMM-yyyy",                                
                                placeholder:"DD-MMM-YYYY"
                            },
                            {
                                id:"consent_not_obtained_reason",
                                type:"text",
                                label:"If NO provide reason",
                                showIf:{
                                    field:"consent_obtained",
                                    value:"NO"
                                },
                                required:true
                            }
                        ]
                    }
                ]
            },
            {
                id: "section_1_eligibility",
                order: 1,
                title: "Section 1: Inclusion and Exclusion Criteria",
                subsections: [
                    {
                        id: "inclusion_criteria",
                        title: "Inclusion Criteria",
                        description: "All criteria must be met for patient to be eligible for the study",
                        fields: [
                            {
                                id: "inclusion_criteria_list",
                                type: "info",
                                items: [
                                    "Patients ≥18 years of age",
                                    "Previously diagnosed with T2DM (with or without comorbidities) coming for follow-up and undergoing treatment",
                                    "Willing to provide written informed consent and compliant with the study procedures"
                                ]
                            },
                            {
                                id: "inclusion_eligible",
                                type: "radio",
                                label: "Does the patient meet ALL of the above inclusion criteria?",
                                options: ["YES", "NO"],
                                required: true
                            }
                        ]
                    },
                    {
                        id: "exclusion_criteria",
                        title: "Exclusion Criteria",
                        description: "Patient must NOT meet any of these criteria to be eligible for the study",
                        fields: [
                            {
                                id: "exclusion_criteria_list",
                                type: "info",
                                items: [
                                    "Patients with T1DM and/or Gestational diabetes",
                                    "Pregnant or lactating women or those planning pregnancy during the study period",
                                    "Participants in another clinical trial"
                                ]
                            },
                            {
                                id: "exclusion_eligible",
                                type: "radio",
                                label: "Does the patient meet ANY of the above exclusion criteria?",
                                options: ["YES", "NO"],
                                required: true
                            }
                        ]
                    }
                ]
            },
            {
                id: "section_2_lifestyle",
                order: 2,
                title: "Section 2: Demographics, Personal Details, Alcohol Smoking Status",
                subsections: [           
                    {
                        id: "demographics",
                        title: "Demographics",
                        fields: [
                            {
                                id: "age",
                                type: "number",
                                label: "Age (in Years)",
                                required: true,
                                width: 50,
                                validation: {
                                    min: 18,
                                    max: 99,
                                    maxLength: 3
                                }
                            },
                            {
                                id: "gender",
                                type: "radio",
                                label: "Gender",
                                options: ["Male", "Female"],
                                required: true,
                                width: 50
                            },
                            {
                                id: "height",
                                type: "number",
                                label: "Height (cm)",
                                required: true,
                                width: 50,
                                validation: {
                                    min: 50,
                                    max: 250,
                                    maxLength: 3
                                }
                            },
                            {
                                id: "weight",
                                type: "number",
                                label: "Weight (kg)",
                                required: true,
                                width: 50,
                                validation: {
                                    min: 20,
                                    max: 250,
                                    maxLength: 3,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "bmi",
                                type: "calculated",
                                label: "Body Mass Index (kg/m²)",
                                formula: "weight / ((height / 100) ** 2)",
                                dependencies: ["height", "weight"],
                                width: 100
                            },
                            {
                                id: "waist_circumference",
                                type: "number",
                                label: "Waist circumference (cm)",
                                required: true,
                                width: 50,
                                validation: {
                                    min: 35,
                                    max: 200,
                                    maxLength: 3
                                }
                            },
                            {
                                id: "hip_circumference",
                                type: "number",
                                label: "Hip circumference (cm)",
                                required: true,
                                width: 50,
                                validation: {
                                    min: 40,
                                    max: 200,
                                    maxLength: 3
                                }
                            },
                            {
                                id: "location_state",
                                type: "text",
                                label: "Location",
                                required: false,
                                width: 50
                            },
                            {
                                id: "state",
                                type: "select",
                                label: "State",
                                required: true,
                                width: 50,
                                options: [
                                    "Andaman and Nicobar Islands",
                                    "Andhra Pradesh",
                                    "Arunachal Pradesh",
                                    "Assam",
                                    "Bihar",
                                    "Chandigarh",
                                    "Chhattisgarh",
                                    "Dadra and Nagar Haveli and Daman and Diu",
                                    "Delhi",
                                    "Goa",
                                    "Gujarat",
                                    "Haryana",
                                    "Himachal Pradesh",
                                    "Jammu and Kashmir",
                                    "Jharkhand",
                                    "Karnataka",
                                    "Kerala",
                                    "Ladakh",
                                    "Lakshadweep",
                                    "Madhya Pradesh",
                                    "Maharashtra",
                                    "Manipur",
                                    "Meghalaya",
                                    "Mizoram",
                                    "Nagaland",
                                    "Odisha",
                                    "Puducherry",
                                    "Punjab",
                                    "Rajasthan",
                                    "Sikkim",
                                    "Tamil Nadu",
                                    "Telangana",
                                    "Tripura",
                                    "Uttar Pradesh",
                                    "Uttarakhand",
                                    "West Bengal"
                                ]
                            }
                        ]
                    },
                    {
                        id: "personal_details",
                        title: "Personal Details",
                        fields: [
                            {
                                id: "marital_status",
                                type: "radio",
                                label: "Marital Status",
                                options: ["Single", "Married", "Divorced/Separated"],
                                required: false,
                                width: 50
                            },
                            {
                                id: "education",
                                type: "select",
                                label: "Educational Qualification (Highest)",
                                options: [
                                    "Illiterate (No formal education)",
                                    "Matriculation or lower (completed school)",
                                    "Higher Secondary / Intermediate (Class 11–12 passed)",
                                    "Diploma / Vocational training",
                                    "Graduate (Bachelor's degree)",
                                    "Postgraduate (Master's degree)",
                                    "Professional / Doctoral degree (MBBS, MD, PhD, CA, etc.)"
                                ],
                                required: false,
                                width: 50
                            },
                            {
                                id: "employment_status",
                                type: "radio",
                                label: "Employment Status",
                                options: ["Employed", "Unemployed"],
                                required: false,
                                width: 50
                            },
                            {
                                id: "lifestyle",
                                type: "radio",
                                label: "Lifestyle",
                                options: ["Sedentary", "Active"],
                                required: false,
                                width: 50
                            },
                            {
                                id: "lifestyle_info",
                                type: "info",
                                variant: "plain",
                                items: [
                                    "#Sedentary Lifestyle: Periods of low energy expenditure (EE) [EE ≤ 1.5 Metabolic Equivalents (METs)] such as sitting, reclining, watching TV.",
                                    "Active Lifestyle: Meeting minimum physical activity guidelines (150-300 mins/week moderate aerobic activity for adults) and reducing sedentary time."
                                ]
                            }
                        ]
                    },
                    {
                        id: "lifestyle_assessment",
                        title: "Alcohol and Smoking Status",
                        fields: [
                            {
                                id: "smoking_yesno",
                                type: "radio",
                                label: "Smoking Status",
                                options: ["YES", "NO"],
                                required: true
                            },
                            {
                                id: "smoking_type",
                                type: "radio",
                                label: "If yes, specify type",
                                showIf: {
                                    field: "smoking_yesno",
                                    value: "YES"
                                },
                                options: ["Current smoker", "Past smoker"],
                                required: true
                            },
                            {
                                id: "smoking_duration_years_current",
                                type: "number",
                                label: "Duration (in years)",
                                showIf: {
                                    field: "smoking_type",
                                    value: "Current smoker"
                                },
                                required: true,
                                width: 50,
                                validation: {
                                    min: 1,
                                    max: 90,
                                    maxLength: 2,
                                    pattern: "numeric"
                                }
                            },
                            {
                                id: "smoking_duration_years_past",
                                type: "number",
                                label: "Duration of years (smoking)",
                                showIf: {
                                    field: "smoking_type",
                                    value: "Past smoker"
                                },
                                required: true,
                                width: 50,
                                validation: {
                                    min: 1,
                                    max: 90,
                                    maxLength: 2,
                                    pattern: "numeric"
                                }
                            },
                            {
                                id: "smoking_years_after_quitting",
                                type: "number",
                                label: "Number of years after quitting",
                                showIf: {
                                    field: "smoking_type",
                                    value: "Past smoker"
                                },
                                required: true,
                                width: 50,
                                validation: {
                                    min: 1,
                                    max: 90,
                                    maxLength: 2,
                                    pattern: "numeric"
                                }
                            },
                            {
                                id: "smoking_frequency",
                                type: "number",
                                label: "Frequency (Pack per day)",
                                showIf: {
                                    field: "smoking_yesno",
                                    value: "YES"
                                },
                                required: true,
                                width: 50
                            },
                            {
                                id: "alcohol_yesno",
                                type: "radio",
                                label: "Alcohol Consumption",
                                options: ["YES", "NO"],
                                required: true
                            },
                            {
                                id: "alcohol_type",
                                type: "radio",
                                label: "If yes, specify type",
                                showIf: {
                                    field: "alcohol_yesno",
                                    value: "YES"
                                },
                                options: ["Current drinker", "Past drinker"],
                                required: true
                            },
                            {
                                id: "alcohol_duration_years_current",
                                type: "number",
                                label: "Duration (in years)",
                                showIf: {
                                    field: "alcohol_type",
                                    value: "Current drinker"
                                },
                                required: true,
                                width: 50,
                                validation: {
                                    min: 1,
                                    max: 90,
                                    maxLength: 2,
                                    pattern: "numeric"
                                }
                            },
                            {
                                id: "alcohol_duration_years_past",
                                type: "number",
                                label: "Duration of years (drinking)",
                                showIf: {
                                    field: "alcohol_type",
                                    value: "Past drinker"
                                },
                                required: true,
                                width: 50,
                                validation: {
                                    min: 1,
                                    max: 90,
                                    maxLength: 2,
                                    pattern: "numeric"
                                }
                            },
                            {
                                id: "alcohol_years_after_quitting",
                                type: "number",
                                label: "Number of years after quitting",
                                showIf: {
                                    field: "alcohol_type",
                                    value: "Past drinker"
                                },
                                required: true,
                                width: 50,
                                validation: {
                                    min: 1,
                                    max: 90,
                                    maxLength: 2,
                                    pattern: "numeric"
                                }
                            },
                            {
                                id: "alcohol_quantity",
                                type: "number",
                                label: "Quantity per day (ml)",
                                showIf: {
                                    field: "alcohol_yesno",
                                    value: "YES"
                                },
                                required: true,
                                width: 50
                            }
                        ]
                    }
                ]
            },
            {
                id: "section_3_medical_history",
                order: 3,
                title: "Section 3: Vital Signs, Diabetes Status, Medical History, Family History",
                subsections: [
                    {
                        id: "vital_signs",
                        title: "Vital Signs",
                        fields: [
                            {
                                id: "blood_pressure_systolic",
                                type: "number",
                                label: "Blood Pressure Systolic (mmHg)",
                                required: true,
                                width: 50,
                                validation: {
                                    min: 40,
                                    max: 350,
                                    maxLength: 3
                                }
                            },
                            {
                                id: "blood_pressure_diastolic",
                                type: "number",
                                label: "Blood Pressure Diastolic (mmHg)",
                                required: true,
                                width: 50,
                                validation: {
                                    min: 20,
                                    max: 250,
                                    maxLength: 3
                                }
                            },
                            {
                                id: "pulse",
                                type: "number",
                                label: "Pulse (beats/minute)",
                                required: true,
                                width: 50,
                                validation: {
                                    min: 1,
                                    max: 220,
                                    maxLength: 3
                                }
                            }
                        ]
                    },
                    {
                        id: "diabetes_status",
                        title: "Diabetes Status",
                        fields: [
                            {
                                id: "diabetes_duration_years",
                                type: "number",
                                label: "Duration of Diabetes (Years)",
                                required: true,
                                width: 50,
                                validation: {
                                    min: 0,
                                    max: 90,
                                    maxLength: 2
                                }
                            },
                            {
                                id: "diabetes_duration_months",
                                type: "number",
                                label: "Duration of Diabetes (Months)",
                                width: 50,
                                validation: {
                                    min: 1,
                                    max: 12,
                                    maxLength: 2
                                }
                            }
                        ]
                    },
                    {
                        id: "medical_history",
                        title: "Medical History",
                        fields: [
                            {
                                id: "has_medical_history",
                                type: "radio",
                                label: "Does the subject have any relevant medical history (Please see below for key medical history)?",
                                options: ["YES", "NO"],
                                required: true
                            },
                            {
                                id: "obesity",
                                type: "checkbox",
                                label: "Obesity (Individuals with body mass index ≥ 25 kg/m²)",
                                showIf: {
                                    field: "has_medical_history",
                                    value: "YES"
                                },
                                width: 100,
                                linkedField: {
                                    id: "obesity_duration_years",
                                    type: "number",
                                    label: "Duration (Years)",
                                    validation: {
                                        min: 1,
                                        max: 90,
                                        maxLength: 2,
                                        pattern: "numeric"
                                    }
                                }
                            },
                            {
                                id: "hypertension",
                                type: "checkbox",
                                label: "Hypertension (≥140/90mmHg or on antihypertensive treatment)",
                                showIf: {
                                    field: "has_medical_history",
                                    value: "YES"
                                },
                                width: 100,
                                linkedField: {
                                    id: "hypertension_duration_years",
                                    type: "number",
                                    label: "Duration (Years)",
                                    validation: {
                                        min: 1,
                                        max: 90,
                                        maxLength: 2,
                                        pattern: "numeric"
                                    }
                                }
                            },
                            {
                                id: "dyslipidemia",
                                type: "checkbox",
                                label: "Dyslipidemia (on lipid-lowering treatment)",
                                showIf: {
                                    field: "has_medical_history",
                                    value: "YES"
                                },
                                width: 100,
                                linkedField: {
                                    id: "dyslipidemia_duration_years",
                                    type: "number",
                                    label: "Duration (Years)",
                                    validation: {
                                        min: 1,
                                        max: 90,
                                        maxLength: 2,
                                        pattern: "numeric"
                                    }
                                }
                            },
                            {
                                id: "chronic_kidney_disease",
                                type: "checkbox",
                                label: "Chronic Kidney Disease (Individuals with eGFR <60mL/min/1.73m² and/or albuminuria >30 mg/g for at least 3 months)",
                                showIf: {
                                    field: "has_medical_history",
                                    value: "YES"
                                },
                                width: 100,
                                linkedField: {
                                    id: "chronic_kidney_disease_duration_years",
                                    type: "number",
                                    label: "Duration (Years)",
                                    validation: {
                                        min: 1,
                                        max: 90,
                                        maxLength: 2,
                                        pattern: "numeric"
                                    }
                                }
                            },
                            {
                                id: "steatotic_liver_disease",
                                type: "checkbox",
                                label: "Steatotic Liver Disease ((clinical diagnosis))",
                                showIf: {
                                    field: "has_medical_history",
                                    value: "YES"
                                },
                                width: 100,
                                linkedField: {
                                    id: "steatotic_liver_disease_duration_years",
                                    type: "number",
                                    label: "Duration (Years)",
                                    validation: {
                                        min: 1,
                                        max: 90,
                                        maxLength: 2,
                                        pattern: "numeric"
                                    }
                                }
                            },
                            {
                                id: "heart_failure",
                                type: "checkbox",
                                label: "Heart Failure (Individuals with symptoms of heart failure and with LVEF ≤40 or >40)",
                                showIf: {
                                    field: "has_medical_history",
                                    value: "YES"
                                },
                                width: 100,
                                linkedField: {
                                    id: "heart_failure_duration_years",
                                    type: "number",
                                    label: "Duration (Years)",
                                    validation: {
                                        min: 1,
                                        max: 90,
                                        maxLength: 2,
                                        pattern: "numeric"
                                    }
                                }
                            },
                            {
                                id: "ascvd",
                                type: "checkbox",
                                label: "ASCVD (Individuals with established CVD (e.g. myocardial infarction, stroke, revascularization procedure))",
                                showIf: {
                                    field: "has_medical_history",
                                    value: "YES"
                                },
                                width: 100,
                                linkedField: {
                                    id: "ascvd_duration_years",
                                    type: "number",
                                    label: "Duration (Years)",
                                    validation: {
                                        min: 1,
                                        max: 90,
                                        maxLength: 2,
                                        pattern: "numeric"
                                    }
                                }
                            },
                            {
                                id: "retinopathy",
                                type: "checkbox",
                                label: "Retinopathy (clinical diagnosis)",
                                showIf: {
                                    field: "has_medical_history",
                                    value: "YES"
                                },
                                width: 100,
                                linkedField: {
                                    id: "retinopathy_duration_years",
                                    type: "number",
                                    label: "Duration (Years)",
                                    validation: {
                                        min: 1,
                                        max: 90,
                                        maxLength: 2,
                                        pattern: "numeric"
                                    }
                                }
                            },
                            {
                                id: "neuropathy",
                                type: "checkbox",
                                label: "Neuropathy (clinical diagnosis)",
                                showIf: {
                                    field: "has_medical_history",
                                    value: "YES"
                                },
                                width: 100,
                                linkedField: {
                                    id: "neuropathy_duration_years",
                                    type: "number",
                                    label: "Duration (Years)",
                                    validation: {
                                        min: 1,
                                        max: 90,
                                        maxLength: 2,
                                        pattern: "numeric"
                                    }
                                }
                            },
                            {
                                id: "other_conditions",
                                type: "checkbox",
                                label: "Others",
                                showIf: {
                                    field: "has_medical_history",
                                    value: "YES"
                                },
                                width: 100,
                                linkedField: {
                                    id: "other_conditions_text",
                                    type: "text",
                                    label: "Please mention"
                                }
                            }
                        ]
                    },
                    {
                        id: "family_history",
                        title: "Family History",
                        fields: [
                            {
                                id: "has_family_history",
                                type: "radio",
                                label: "Does any of your parents have any medical history (Please record all relevant medical history below)?",
                                options: ["YES", "NO"],
                                required: true
                            },
                            {
                                id: "family_obesity",
                                type: "checkbox",
                                label: "Obesity",
                                showIf: {
                                    field: "has_family_history",
                                    value: "YES"
                                },
                                width: 50
                            },
                            {
                                id: "family_hypertension",
                                type: "checkbox",
                                label: "Hypertension",
                                showIf: {
                                    field: "has_family_history",
                                    value: "YES"
                                },
                                width: 50
                            },
                            {
                                id: "family_dyslipidemia",
                                type: "checkbox",
                                label: "Dyslipidemia",
                                showIf: {
                                    field: "has_family_history",
                                    value: "YES"
                                },
                                width: 50
                            },
                            {
                                id: "family_chronic_kidney_disease",
                                type: "checkbox",
                                label: "Chronic Kidney Disease",
                                showIf: {
                                    field: "has_family_history",
                                    value: "YES"
                                },
                                width: 50
                            },
                            {
                                id: "family_steatotic_liver_disease",
                                type: "checkbox",
                                label: "Steatotic Liver Disease (clinical diagnosis)",
                                showIf: {
                                    field: "has_family_history",
                                    value: "YES"
                                },
                                width: 50
                            },
                            {
                                id: "family_heart_failure",
                                type: "checkbox",
                                label: "Heart Failure",
                                showIf: {
                                    field: "has_family_history",
                                    value: "YES"
                                },
                                width: 50
                            },
                            {
                                id: "family_ascvd",
                                type: "checkbox",
                                label: "ASCVD",
                                showIf: {
                                    field: "has_family_history",
                                    value: "YES"
                                },
                                width: 50
                            },
                            {
                                id: "family_retinopathy",
                                type: "checkbox",
                                label: "Retinopathy (clinical diagnosis)",
                                showIf: {
                                    field: "has_family_history",
                                    value: "YES"
                                },
                                width: 50
                            },
                            {
                                id: "family_neuropathy",
                                type: "checkbox",
                                label: "Neuropathy (clinical diagnosis)",
                                showIf: {
                                    field: "has_family_history",
                                    value: "YES"
                                },
                                width: 50
                            }
                        ]
                    }
                ]
            },
            {
                id: "section_4_investigations",
                order: 4,
                title: "Section 4: Investigation Details, Prior and Concomitant Medications",
                subsections: [
                    {
                        id: "investigations",
                        title: "Investigation Details",
                        fields: [
                            {
                                id: "lab_report_available",
                                type: "radio",
                                label: "Was Lab Report Available within past 6 months?",
                                options: ["YES", "NO"],
                                required: true
                            },
                            {
                                id: "lab_report_date",
                                type: "date",
                                label: "Lab Report Date",
                                required: true,
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                placeholder: "DD-MMM-YYYY",
                                validation: {
                                    lastSixMonthsOnly: true
                                }
                            },
                            {
                                id: "hba1c",
                                type: "number",
                                label: "HbA1c (%)",
                                required: true,
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50,
                                validation: {
                                    min: 3,
                                    max: 20,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "fpg",
                                type: "number",
                                label: "FPG (mg/dL)",
                                required: true,
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50,
                                validation: {
                                    min: 20,
                                    max: 800,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "ppg",
                                type: "number",
                                label: "PPG (mg/dL)",
                                required: true,
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50,
                                validation: {
                                    min: 20,
                                    max: 800,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "total_cholesterol",
                                type: "number",
                                label: "Total Cholesterol - TC (mg/dL)",
                                required: true,
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50,
                                validation: {
                                    min: 50,
                                    max: 1000,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "ldl_c",
                                type: "number",
                                label: "LDL-C (mg/dL)",
                                required: true,
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50,
                                validation: {
                                    min: 10,
                                    max: 800,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "hdl_c",
                                type: "number",
                                label: "HDL-C (mg/dL)",
                                required: true,
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50,
                                validation: {
                                    min: 5,
                                    max: 250,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "non_hdl_c",
                                type: "number",
                                label: "Non-HDL-C (mg/dL)",
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50,
                                validation: {
                                    min: 10,
                                    max: 900,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "vldl_c",
                                type: "number",
                                label: "VLDL-C (mg/dL)",
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50,
                                validation: {
                                    min: 1,
                                    max: 300,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "triglycerides",
                                type: "number",
                                label: "Triglycerides - TG (mg/dL)",
                                required: true,
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50,
                                validation: {
                                    min: 20,
                                    max: 10000,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "egfr",
                                type: "number",
                                label: "eGFR (mL/min/1.73m²)",
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50,
                                validation: {
                                    min: 0,
                                    max: 200,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "uacr",
                                type: "number",
                                label: "UACR (mg/g)",
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50,
                                validation: {
                                    min: 0,
                                    max: 10000,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "serum_creatinine",
                                type: "number",
                                label: "Serum Creatinine (mg/dL)",
                                required: true,
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50,
                                validation: {
                                    min: 0.1,
                                    max: 40,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "lvef",
                                type: "number",
                                label: "LVEF - if HF suspected (%)",
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50,
                                validation: {
                                    min: 5,
                                    max: 100,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "ast",
                                type: "number",
                                label: "AST (U/L)",
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50,
                                validation: {
                                    min: 5,
                                    max: 100,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "alt",
                                type: "number",
                                label: "ALT (U/L)",
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50,
                                validation: {
                                    min: 1,
                                    max: 4000,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "platelet_count",
                                type: "number",
                                label: "Platelet Count (thou/μL)",    
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },                            
                                width: 50,
                                validation: {
                                    min: 10000,
                                    max: 2000000 ,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "fib4_score",
                                type: "calculated",
                                label: "FIB-4 Score (Calculated)",
                                formula: "(age * ast) / (platelet_count * Math.sqrt(alt))",
                                dependencies: ["age", "ast", "alt", "platelet_count"],
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50
                            }
                        ]
                    },
                    {
                        id: "existing_medications",
                        title: "Existing Medications",
                        fields: [
                            {
                                id: "existing_medication_table",
                                type: "table",
                                label: "Medication Log",
                                required: false,
                                columns: [
                                    {
                                        id: "PCMMDCS",
                                        type: "select",
                                        label: "Medication Class",
                                        required: true,
                                        options: [
                                            "Antihyperglycemic"
                                        ]
                                    },
                                    {
                                        id: "PCMNAME",
                                        type: "text",
                                        label: "Medication Name",
                                        required: true
                                    },
                                    {
                                        id: "PCMDOSE",
                                        type: "number",
                                        label: "Dose",
                                        required: true
                                    },
                                    {
                                        id: "PCMUNIT",
                                        type: "select",
                                        label: "Unit",
                                        required: true,
                                        width: 100,
                                        options: ["g", "mg", "�g", "ml", "U", "IU"]
                                    },
                                    {
                                        id: "PCMDFM",
                                        type: "select",
                                        label: "Dosage Form",
                                        required: true,
                                        options: ["Tablet", "Capsule", "Syrup", "Injection", "Powder", "Others"]
                                    },
                                    {
                                        id: "PCMFREQ",
                                        type: "select",
                                        label: "Frequency",
                                        required: true,
                                        width: 70,
                                        options: ["OD", "BD", "TID", "QID", "PRN", "Others"]
                                    },
                                    {
                                        id: "pc1start_date",
                                        label: "Start Date",
                                        type: "date",
                                        width: 130,
                                        required: true
                                    },
                                    {
                                        id: "pc1stop_date",
                                        label: "Stop Date",
                                        width: 130,
                                        type: "date"
                                    },
                                    {
                                        id: "pc1ongoing",
                                        label: "Ongoing",
                                        width: 80,
                                        type: "checkbox"
                                    },
                                    {
                                        id: "PC1MDUR",
                                        type: "text",
                                        label: "Duration",
                                        disabled: true                                        
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        id: "medications",
                        title: "Prior & Concomitant Medications",
                        fields: [
                            {
                                id: "antihyperglycemic_table",
                                type: "table",
                                label: "Please record details of anti-hyperglycemics taken by the patient during the study visit.",
                                required: true,
                                columns: [
                                    {
                                        id: "PCMMDCS",
                                        type: "select",
                                        label: "Medication Class",
                                        required: true,
                                        options: [
                                            "Antihyperglycemic"
                                        ]
                                    },
                                    {
                                        id: "PCMNAME",
                                        type: "text",
                                        label: "Medication Name",
                                        required: true
                                    },
                                    {
                                        id: "PCMDOSE",
                                        type: "number",
                                        label: "Dose",
                                        required: true
                                    },
                                    {
                                        id: "PCMUNIT",
                                        type: "select",
                                        label: "Unit",
                                        required: true,
                                        width: 100,
                                        options: ["g", "mg", "µg", "ml", "U", "IU"]
                                    },
                                    {
                                        id: "PCMDFM",
                                        type: "select",
                                        label: "Dosage Form",
                                        required: true,
                                        options: ["Tablet", "Capsule", "Syrup", "Injection", "Powder", "Others"]
                                    },
                                    {
                                        id: "PCMFREQ",
                                        type: "select",
                                        label: "Frequency",
                                        required: true,
                                        width: 70,
                                        options: ["OD", "BD", "TID", "QID", "PRN", "Others"]
                                    },
                                    {
                                        id: "pc2start_date",
                                        label: "Start Date",
                                        type: "date",
                                        width: 130
                                    },
                                    {
                                        id: "pc2stop_date",
                                        label: "Stop Date",
                                        width: 130,
                                        type: "date"
                                    },
                                    {
                                        id: "pc2ongoing",
                                        label: "Ongoing",
                                        width: 80,
                                        type: "checkbox"
                                    },
                                    {
                                        id: "PC2MDUR",
                                        type: "text",
                                        label: "Duration",
                                        disabled: true
                                    }
                                ]
                            },
                            {
                                id: "has_concomitant_meds",
                                type: "radio",
                                label: "Has the patient taken any concomitant medications (along with anti-hyperglycemics) since the last 28 days or is taking during the study visit? (For e.g., Antihypertensive, Lipid lowering, Antiplatelets, Heart Failure medication, Anti-obesity or OTC medications, vitamins, herbal remedies, etc. as per relevance)",
                                options: ["YES", "NO"],
                                required: true,
                                boldLabel: true
                            },
                            {
                                id: "medication_table",
                                type: "table",
                                label: "",
                                showIf: {
                                    field: "has_concomitant_meds",
                                    value: "YES"
                                },
                                required: true,
                                columns: [
                                    {
                                        id: "PCMMDCS",
                                        type: "select",
                                        label: "Medication Class",
                                        required: true,
                                        options: [
                                            "Antihypertensive",
                                            "Lipid lowering",
                                            "Antiplatelets",
                                            "Heart Failure medication",
                                            "Antiobesity",
                                            "Others"
                                        ]
                                    },
                                    {
                                        id: "PCMMDCS_OTHER",
                                        type: "text",
                                        label: "Specify Medication Class",
                                        required: true,
                                        showIf: {
                                            field: "PCMMDCS",
                                            value: "Others"
                                        }
                                    },
                                    {
                                        id: "PCMNAME",
                                        type: "text",
                                        label: "Medication Name",
                                        required: true
                                    },
                                    {
                                        id: "PCMDOSE",
                                        type: "number",
                                        label: "Dose",
                                        required: true
                                    },
                                    {
                                        id: "PCMUNIT",
                                        type: "select",
                                        label: "Unit",
                                        required: true,
                                        width: 100,
                                        options: ["g", "mg", "µg", "ml", "U", "IU"]
                                    },
                                    {
                                        id: "PCMDFM",
                                        type: "select",
                                        label: "Dosage Form",
                                        required: true,
                                        options: ["Tablet", "Capsule", "Syrup", "Injection", "Powder", "Others"]
                                    },
                                    {
                                        id: "PCMFREQ",
                                        type: "select",
                                        label: "Frequency",
                                        required: true,
                                        width: 70,
                                        options: ["OD", "BD", "TID", "QID", "PRN", "Others"]
                                    },
                                    {
                                        id: "pc3start_date",
                                        label: "Start Date",
                                        type: "date",
                                        width: 130,
                                        required: true
                                    },
                                    {
                                        id: "pc3stop_date",
                                        label: "Stop Date",
                                        width: 130,
                                        type: "date"
                                    },
                                    {
                                        id: "pc3ongoing",
                                        label: "Ongoing",
                                        width: 80,
                                        type: "checkbox"
                                    },
                                    {
                                        id: "PC3MDUR",
                                        type: "text",
                                        label: "Duration",
                                        disabled: true
                                    }
                                ]
                            },
                            {
                                id: "concomitant_meds_comments",
                                type: "textarea",
                                label: "Comments",
                                width: 100,
                                placeholder: "Enter any additional comments"
                            }
                        ]
                    }
                ]
            },
            {
                id: "section_5_declaration",
                order: 5,
                title: "Section 5: Investigator Declaration",
                subsections: [
                    {
                        id: "investigator_declaration",
                        title: "Declaration",
                        description: "I have reviewed the data entries for all pages in this Case Report Form. To the best of my knowledge, they are complete, accurate and compatible with the source documents. All entries were either made by myself or a person under my supervision who has signed the Delegation Log.",
                        fields: [
                            {
                                id: "investigator_signature",
                                type: "signature",
                                label: "Signature",
                                required: true
                            }
                        ]
                    }
                ]
            }
        ]
    },
    "2": {
        id: "insights_study_crf_v1",
        title: "INSIGHTS Study - Type 2 Diabetes Mellitus Case Report Form",
        sections: [
            {
                id:"section_0_consent",
                order:0,
                title:"Informed Consent",
                subsections:[
                    {
                        id:"informed_consent_details",
                        fields:[
                            {
                                id:"consent_obtained",
                                type:"radio",
                                label:"Was informed consent obtained?",
                                options:["YES","NO"],
                                required:true
                            },
                            {
                                id:"consent_date",
                                type:"date",
                                label:"Consent Date",
                                showIf:{
                                    field:"consent_obtained",
                                    value:"YES"
                                },
                                required:true,
                                format:"dd-MMM-yyyy",                                
                                placeholder:"DD-MMM-YYYY"
                            },
                            {
                                id:"consent_not_obtained_reason",
                                type:"text",
                                label:"If NO provide reason",
                                showIf:{
                                    field:"consent_obtained",
                                    value:"NO"
                                },
                                required:true
                            }
                        ]
                    }
                ]
            },
            {
                id: "section_1_eligibility",
                order: 1,
                title: "Section 1: Inclusion and Exclusion Criteria",
                subsections: [
                    {
                        id: "inclusion_criteria",
                        title: "Inclusion Criteria",
                        description: "All criteria must be met for patient to be eligible for the study",
                        fields: [
                            {
                                id: "inclusion_criteria_list",
                                type: "info",
                                items: [
                                    "Patients ≥18 years of age",
                                    "Previously diagnosed with T2DM (with or without comorbidities) coming for follow-up and undergoing treatment",
                                    "Willing to provide written informed consent and compliant with the study procedures"
                                ]
                            },
                            {
                                id: "inclusion_eligible",
                                type: "radio",
                                label: "Does the patient meet ALL of the above inclusion criteria?",
                                options: ["YES", "NO"],
                                required: true
                            }
                        ]
                    },
                    {
                        id: "exclusion_criteria",
                        title: "Exclusion Criteria",
                        description: "Patient must NOT meet any of these criteria to be eligible for the study",
                        fields: [
                            {
                                id: "exclusion_criteria_list",
                                type: "info",
                                items: [
                                    "Patients with T1DM and/or Gestational diabetes",
                                    "Pregnant or lactating women or those planning pregnancy during the study period",
                                    "Participants in another clinical trial"
                                ]
                            },
                            {
                                id: "exclusion_eligible",
                                type: "radio",
                                label: "Does the patient meet ANY of the above exclusion criteria?",
                                options: ["YES", "NO"],
                                required: true
                            }
                        ]
                    }
                ]
            },
            {
                id: "section_2_lifestyle",
                order: 2,
                title: "Section 2: Demographics, Personal Details, Alcohol Smoking Status",
                subsections: [
                    {
                        id: "demographics",
                        title: "Demographics",
                        fields: [
                            {
                                id: "age",
                                type: "number",
                                label: "Age (in Years)",
                                required: true,
                                width: 50,
                                validation: {
                                    min: 18,
                                    max: 99,
                                    maxLength: 3
                                }
                            },
                            {
                                id: "gender",
                                type: "radio",
                                label: "Gender",
                                options: ["Male", "Female"],
                                required: true,
                                width: 50
                            },
                            {
                                id: "height",
                                type: "number",
                                label: "Height (cm)",
                                required: true,
                                width: 50,
                                validation: {
                                    min: 50,
                                    max: 250,
                                    maxLength: 3
                                }
                            },
                            {
                                id: "weight",
                                type: "number",
                                label: "Weight (kg)",
                                required: true,
                                width: 50,
                                validation: {
                                    min: 20,
                                    max: 250,
                                    maxLength: 3,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "bmi",
                                type: "calculated",
                                label: "Body Mass Index (kg/m²)",
                                formula: "weight / ((height / 100) ** 2)",
                                dependencies: ["height", "weight"],
                                width: 100
                            },
                            {
                                id: "waist_circumference",
                                type: "number",
                                label: "Waist circumference (cm)",
                                required: true,
                                width: 50,
                                validation: {
                                    min: 35,
                                    max: 200,
                                    maxLength: 3
                                }
                            },
                            {
                                id: "hip_circumference",
                                type: "number",
                                label: "Hip circumference (cm)",
                                required: true,
                                width: 50,
                                validation: {
                                    min: 40,
                                    max: 200,
                                    maxLength: 3
                                }
                            },
                            {
                                id: "location_state",
                                type: "text",
                                label: "Location",
                                required: false,
                                width: 50
                            },
                            {
                                id: "state",
                                type: "select",
                                label: "State",
                                required: true,
                                width: 50,
                                options: [
                                    "Andaman and Nicobar Islands",
                                    "Andhra Pradesh",
                                    "Arunachal Pradesh",
                                    "Assam",
                                    "Bihar",
                                    "Chandigarh",
                                    "Chhattisgarh",
                                    "Dadra and Nagar Haveli and Daman and Diu",
                                    "Delhi",
                                    "Goa",
                                    "Gujarat",
                                    "Haryana",
                                    "Himachal Pradesh",
                                    "Jammu and Kashmir",
                                    "Jharkhand",
                                    "Karnataka",
                                    "Kerala",
                                    "Ladakh",
                                    "Lakshadweep",
                                    "Madhya Pradesh",
                                    "Maharashtra",
                                    "Manipur",
                                    "Meghalaya",
                                    "Mizoram",
                                    "Nagaland",
                                    "Odisha",
                                    "Puducherry",
                                    "Punjab",
                                    "Rajasthan",
                                    "Sikkim",
                                    "Tamil Nadu",
                                    "Telangana",
                                    "Tripura",
                                    "Uttar Pradesh",
                                    "Uttarakhand",
                                    "West Bengal"
                                ]
                            }
                        ]
                    },
                    {
                        id: "personal_details",
                        title: "Personal Details",
                        fields: [
                            {
                                id: "marital_status",
                                type: "radio",
                                label: "Marital Status",
                                options: ["Single", "Married", "Divorced/Separated"],
                                required: false,
                                width: 50
                            },
                            {
                                id: "education",
                                type: "select",
                                label: "Educational Qualification (Highest)",
                                options: [
                                    "Illiterate (No formal education)",
                                    "Matriculation or lower (completed school)",
                                    "Higher Secondary / Intermediate (Class 11–12 passed)",
                                    "Diploma / Vocational training",
                                    "Graduate (Bachelor's degree)",
                                    "Postgraduate (Master's degree)",
                                    "Professional / Doctoral degree (MBBS, MD, PhD, CA, etc.)"
                                ],
                                required: false,
                                width: 50
                            },
                            {
                                id: "employment_status",
                                type: "radio",
                                label: "Employment Status",
                                options: ["Employed", "Unemployed"],
                                required: false,
                                width: 50
                            },
                            {
                                id: "lifestyle",
                                type: "radio",
                                label: "Lifestyle",
                                options: ["Sedentary", "Active"],
                                required: false,
                                width: 50
                            },
                            {
                                id: "lifestyle_info",
                                type: "info",
                                variant: "plain",
                                items: [
                                    "#Sedentary Lifestyle: Periods of low energy expenditure (EE) [EE ≤ 1.5 Metabolic Equivalents (METs)] such as sitting, reclining, watching TV.",
                                    "Active Lifestyle: Meeting minimum physical activity guidelines (150-300 mins/week moderate aerobic activity for adults) and reducing sedentary time."
                                ]
                            }
                        ]
                    },
                    {
                        id: "lifestyle_assessment",
                        title: "Alcohol and Smoking Status",
                        fields: [
                            {
                                id: "smoking_yesno",
                                type: "radio",
                                label: "Smoking Status",
                                options: ["YES", "NO"],
                                required: true
                            },
                            {
                                id: "smoking_type",
                                type: "radio",
                                label: "If yes,",
                                showIf: {
                                    field: "smoking_yesno",
                                    value: "YES"
                                },
                                options: ["Current smoker", "Past smoker"],
                                required: true
                            },
                            {
                                id: "smoking_duration_years_current",
                                type: "number",
                                label: "Duration (in years)",
                                showIf: {
                                    field: "smoking_type",
                                    value: "Current smoker"
                                },
                                required: true,
                                width: 50,
                                validation: {
                                    min: 1,
                                    max: 90,
                                    maxLength: 2,
                                    pattern: "numeric"
                                }
                            },
                            {
                                id: "smoking_duration_years_past",
                                type: "number",
                                label: "Duration of years (smoking)",
                                showIf: {
                                    field: "smoking_type",
                                    value: "Past smoker"
                                },
                                required: true,
                                width: 50,
                                validation: {
                                    min: 1,
                                    max: 90,
                                    maxLength: 2,
                                    pattern: "numeric"
                                }
                            },
                            {
                                id: "smoking_years_after_quitting",
                                type: "number",
                                label: "Number of years after quitting",
                                showIf: {
                                    field: "smoking_type",
                                    value: "Past smoker"
                                },
                                required: true,
                                width: 50,
                                validation: {
                                    min: 1,
                                    max: 90,
                                    maxLength: 2,
                                    pattern: "numeric"
                                }
                            },
                            {
                                id: "smoking_frequency",
                                type: "number",
                                label: "Frequency (Pack per day)",
                                showIf: {
                                    field: "smoking_yesno",
                                    value: "YES"
                                },
                                required: true,
                                width: 50
                            },
                            {
                                id: "alcohol_yesno",
                                type: "radio",
                                label: "Alcohol Consumption",
                                options: ["YES", "NO"],
                                required: true
                            },
                            {
                                id: "alcohol_type",
                                type: "radio",
                                label: "If yes,",
                                showIf: {
                                    field: "alcohol_yesno",
                                    value: "YES"
                                },
                                options: ["Current drinker", "Past drinker"],
                                required: true
                            },
                            {
                                id: "alcohol_duration_years_current",
                                type: "number",
                                label: "Duration (in years)",
                                showIf: {
                                    field: "alcohol_type",
                                    value: "Current drinker"
                                },
                                required: true,
                                width: 50,
                                validation: {
                                    min: 1,
                                    max: 90,
                                    maxLength: 2,
                                    pattern: "numeric"
                                }
                            },
                            {
                                id: "alcohol_duration_years_past",
                                type: "number",
                                label: "Duration of years (drinking)",
                                showIf: {
                                    field: "alcohol_type",
                                    value: "Past drinker"
                                },
                                required: true,
                                width: 50,
                                validation: {
                                    min: 1,
                                    max: 90,
                                    maxLength: 2,
                                    pattern: "numeric"
                                }
                            },
                            {
                                id: "alcohol_years_after_quitting",
                                type: "number",
                                label: "Number of years after quitting",
                                showIf: {
                                    field: "alcohol_type",
                                    value: "Past drinker"
                                },
                                required: true,
                                width: 50,
                                validation: {
                                    min: 1,
                                    max: 90,
                                    maxLength: 2,
                                    pattern: "numeric"
                                }
                            },
                            {
                                id: "alcohol_quantity",
                                type: "number",
                                label: "Quantity per day (ml)",
                                showIf: {
                                    field: "alcohol_yesno",
                                    value: "YES"
                                },
                                required: true,
                                width: 50
                            }
                        ]
                    }
                ]
            },
            {
                id: "section_3_medical_history",
                order: 3,
                title: "Section 3: Vital Signs, Diabetes Status, Medical History, Family History",
                subsections: [
                    {
                        id: "vital_signs",
                        title: "Vital Signs",
                        fields: [
                            {
                                id: "blood_pressure_systolic",
                                type: "number",
                                label: "Blood Pressure Systolic (mmHg)",
                                required: true,
                                width: 50,
                                validation: {
                                    min: 40,
                                    max: 350,
                                    maxLength: 3
                                }
                            },
                            {
                                id: "blood_pressure_diastolic",
                                type: "number",
                                label: "Blood Pressure Diastolic (mmHg)",
                                required: true,
                                width: 50,
                                validation: {
                                    min: 20,
                                    max: 250,
                                    maxLength: 3
                                }
                            },
                            {
                                id: "pulse",
                                type: "number",
                                label: "Pulse (beats/minute)",
                                required: true,
                                width: 50,
                                validation: {
                                    min: 1,
                                    max: 220,
                                    maxLength: 3
                                }
                            }
                        ]
                    },
                    {
                        id: "diabetes_status",
                        title: "Diabetes Status",
                        fields: [
                            {
                                id: "diabetes_duration_years",
                                type: "number",
                                label: "Duration of Diabetes (Years)",
                                required: true,
                                width: 50,
                                validation: {
                                    min: 0,
                                    max: 90,
                                    maxLength: 2
                                }
                            },
                            {
                                id: "diabetes_duration_months",
                                type: "number",
                                label: "Duration of Diabetes (Months)",
                                width: 50,
                                validation: {
                                    min: 1,
                                    max: 12,
                                    maxLength: 2
                                }
                            }
                        ]
                    },
                    {
                        id: "medical_history",
                        title: "Medical History",
                        fields: [
                            {
                                id: "has_medical_history",
                                type: "radio",
                                label: "Does the subject have any relevant medical history (Please see below for key medical history)?",
                                options: ["YES", "NO"],
                                required: true
                            },
                            {
                                id: "obesity",
                                type: "checkbox",
                                label: "Obesity (Individuals with body mass index ≥ 25 kg/m²)",
                                showIf: {
                                    field: "has_medical_history",
                                    value: "YES"
                                },
                                width: 100,
                                linkedField: {
                                    id: "obesity_duration_years",
                                    type: "number",
                                    label: "Duration (Years)",
                                    validation: {
                                        min: 1,
                                        max: 90,
                                        maxLength: 2,
                                        pattern: "numeric"
                                    }
                                }
                            },
                            {
                                id: "hypertension",
                                type: "checkbox",
                                label: "Hypertension (≥140/90mmHg or on antihypertensive treatment)",
                                showIf: {
                                    field: "has_medical_history",
                                    value: "YES"
                                },
                                width: 100,
                                linkedField: {
                                    id: "hypertension_duration_years",
                                    type: "number",
                                    label: "Duration (Years)",
                                    validation: {
                                        min: 1,
                                        max: 90,
                                        maxLength: 2,
                                        pattern: "numeric"
                                    }
                                }
                            },
                            {
                                id: "dyslipidemia",
                                type: "checkbox",
                                label: "Dyslipidemia (on lipid-lowering treatment)",
                                showIf: {
                                    field: "has_medical_history",
                                    value: "YES"
                                },
                                width: 100,
                                linkedField: {
                                    id: "dyslipidemia_duration_years",
                                    type: "number",
                                    label: "Duration (Years)",
                                    validation: {
                                        min: 1,
                                        max: 90,
                                        maxLength: 2,
                                        pattern: "numeric"
                                    }
                                }
                            },
                            {
                                id: "chronic_kidney_disease",
                                type: "checkbox",
                                label: "Chronic Kidney Disease (Individuals with eGFR <60mL/min/1.73m² and/or albuminuria >30 mg/g for at least 3 months)",
                                showIf: {
                                    field: "has_medical_history",
                                    value: "YES"
                                },
                                width: 100,
                                linkedField: {
                                    id: "chronic_kidney_disease_duration_years",
                                    type: "number",
                                    label: "Duration (Years)",
                                    validation: {
                                        min: 1,
                                        max: 90,
                                        maxLength: 2,
                                        pattern: "numeric"
                                    }
                                }
                            },
                            {
                                id: "steatotic_liver_disease",
                                type: "checkbox",
                                label: "Steatotic Liver Disease (clinical diagnosis)",
                                showIf: {
                                    field: "has_medical_history",
                                    value: "YES"
                                },
                                width: 100,
                                linkedField: {
                                    id: "steatotic_liver_disease_duration_years",
                                    type: "number",
                                    label: "Duration (Years)",
                                    validation: {
                                        min: 1,
                                        max: 90,
                                        maxLength: 2,
                                        pattern: "numeric"
                                    }
                                }
                            },
                            {
                                id: "heart_failure",
                                type: "checkbox",
                                label: "Heart Failure (Individuals with symptoms of heart failure and with LVEF ≤40 or >40)",
                                showIf: {
                                    field: "has_medical_history",
                                    value: "YES"
                                },
                                width: 100,
                                linkedField: {
                                    id: "heart_failure_duration_years",
                                    type: "number",
                                    label: "Duration (Years)",
                                    validation: {
                                        min: 1,
                                        max: 90,
                                        maxLength: 2,
                                        pattern: "numeric"
                                    }
                                }
                            },
                            {
                                id: "ascvd",
                                type: "checkbox",
                                label: "ASCVD (Individuals with established CVD (e.g. myocardial infarction, stroke, revascularization procedure))",
                                showIf: {
                                    field: "has_medical_history",
                                    value: "YES"
                                },
                                width: 100,
                                linkedField: {
                                    id: "ascvd_duration_years",
                                    type: "number",
                                    label: "Duration (Years)",
                                    validation: {
                                        min: 1,
                                        max: 90,
                                        maxLength: 2,
                                        pattern: "numeric"
                                    }
                                }
                            },
                            {
                                id: "retinopathy",
                                type: "checkbox",
                                label: "Retinopathy (clinical diagnosis)",
                                showIf: {
                                    field: "has_medical_history",
                                    value: "YES"
                                },
                                width: 100,
                                linkedField: {
                                    id: "retinopathy_duration_years",
                                    type: "number",
                                    label: "Duration (Years)",
                                    validation: {
                                        min: 1,
                                        max: 90,
                                        maxLength: 2,
                                        pattern: "numeric"
                                    }
                                }
                            },
                            {
                                id: "neuropathy",
                                type: "checkbox",
                                label: "Neuropathy (clinical diagnosis)",
                                showIf: {
                                    field: "has_medical_history",
                                    value: "YES"
                                },
                                width: 100,
                                linkedField: {
                                    id: "neuropathy_duration_years",
                                    type: "number",
                                    label: "Duration (Years)",
                                    validation: {
                                        min: 1,
                                        max: 90,
                                        maxLength: 2,
                                        pattern: "numeric"
                                    }
                                }
                            },
                            {
                                id: "other_conditions",
                                type: "checkbox",
                                label: "Others",
                                showIf: {
                                    field: "has_medical_history",
                                    value: "YES"
                                },
                                width: 100,
                                linkedField: {
                                    id: "other_conditions_text",
                                    type: "text",
                                    label: "Please mention"
                                }
                            }
                        ]
                    },
                    {
                        id: "family_history",
                        title: "Family History",
                        fields: [
                            {
                                id: "has_family_history",
                                type: "radio",
                                label: "Does any of your parents have any medical history (Please record all relevant medical history below)?",
                                options: ["YES", "NO"],
                                required: true
                            },
                            {
                                id: "family_obesity",
                                type: "checkbox",
                                label: "Obesity",
                                showIf: {
                                    field: "has_family_history",
                                    value: "YES"
                                },
                                width: 50
                            },
                            {
                                id: "family_hypertension",
                                type: "checkbox",
                                label: "Hypertension",
                                showIf: {
                                    field: "has_family_history",
                                    value: "YES"
                                },
                                width: 50
                            },
                            {
                                id: "family_dyslipidemia",
                                type: "checkbox",
                                label: "Dyslipidemia",
                                showIf: {
                                    field: "has_family_history",
                                    value: "YES"
                                },
                                width: 50
                            },
                            {
                                id: "family_chronic_kidney_disease",
                                type: "checkbox",
                                label: "Chronic Kidney Disease",
                                showIf: {
                                    field: "has_family_history",
                                    value: "YES"
                                },
                                width: 50
                            },
                            {
                                id: "family_steatotic_liver_disease",
                                type: "checkbox",
                                label: "Steatotic Liver Disease (clinical diagnosis)",
                                showIf: {
                                    field: "has_family_history",
                                    value: "YES"
                                },
                                width: 50
                            },
                            {
                                id: "family_heart_failure",
                                type: "checkbox",
                                label: "Heart Failure",
                                showIf: {
                                    field: "has_family_history",
                                    value: "YES"
                                },
                                width: 50
                            },
                            {
                                id: "family_ascvd",
                                type: "checkbox",
                                label: "ASCVD",
                                showIf: {
                                    field: "has_family_history",
                                    value: "YES"
                                },
                                width: 50
                            },
                            {
                                id: "family_retinopathy",
                                type: "checkbox",
                                label: "Retinopathy (clinical diagnosis)",
                                showIf: {
                                    field: "has_family_history",
                                    value: "YES"
                                },
                                width: 50
                            },
                            {
                                id: "family_neuropathy",
                                type: "checkbox",
                                label: "Neuropathy (clinical diagnosis)",
                                showIf: {
                                    field: "has_family_history",
                                    value: "YES"
                                },
                                width: 50
                            }
                        ]
                    }
                ]
            },
            {
                id: "section_4_investigations",
                order: 4,
                title: "Section 4: Investigation Details, Prior and Concomitant Medications",
                subsections: [
                    {
                        id: "investigations",
                        title: "Investigation Details",
                        fields: [
                            {
                                id: "lab_report_available",
                                type: "radio",
                                label: "Was Lab Report Available within past 6 months?",
                                options: ["YES", "NO"],
                                required: true
                            },
                            {
                                id: "lab_report_date",
                                type: "date",
                                label: "Lab Report Date",
                                required: true,
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                placeholder: "DD-MMM-YYYY",
                                validation: {
                                    lastSixMonthsOnly: true
                                }
                            },
                            {
                                id: "hba1c",
                                type: "number",
                                label: "HbA1c (%)",
                                required: true,
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50,
                                validation: {
                                    min: 3,
                                    max: 20,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "fpg",
                                type: "number",
                                label: "FPG (mg/dL)",
                                required: true,
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50,
                                validation: {
                                    min: 20,
                                    max: 800,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "ppg",
                                type: "number",
                                label: "PPG (mg/dL)",
                                required: true,
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50,
                                validation: {
                                    min: 20,
                                    max: 800,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "total_cholesterol",
                                type: "number",
                                label: "Total Cholesterol - TC (mg/dL)",
                                required: true,
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50,
                                validation: {
                                    min: 50,
                                    max: 1000,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "ldl_c",
                                type: "number",
                                label: "LDL-C (mg/dL)",
                                required: true,
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50,
                                validation: {
                                    min: 10,
                                    max: 800,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "hdl_c",
                                type: "number",
                                label: "HDL-C (mg/dL)",
                                required: true,
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50,
                                validation: {
                                    min: 5,
                                    max: 250,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "non_hdl_c",
                                type: "number",
                                label: "Non-HDL-C (mg/dL)",
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50,
                                validation: {
                                    min: 10,
                                    max: 900,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "vldl_c",
                                type: "number",
                                label: "VLDL-C (mg/dL)",
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50,
                                validation: {
                                    min: 1,
                                    max: 300,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "triglycerides",
                                type: "number",
                                label: "Triglycerides - TG (mg/dL)",
                                required: true,
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50,
                                validation: {
                                    min: 20,
                                    max: 10000,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "egfr",
                                type: "number",
                                label: "eGFR (mL/min/1.73m²)",
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50,
                                validation: {
                                    min: 0,
                                    max: 200,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "uacr",
                                type: "number",
                                label: "UACR (mg/g)",
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50,
                                validation: {
                                    min: 0,
                                    max: 10000,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "serum_creatinine",
                                type: "number",
                                label: "Serum Creatinine (mg/dL)",
                                required: true,
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50,
                                validation: {
                                    min: 0.1,
                                    max: 40,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "lvef",
                                type: "number",
                                label: "LVEF - if HF suspected (%)",
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50,
                                validation: {
                                    min: 5,
                                    max: 100,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "ast",
                                type: "number",
                                label: "AST (U/L)",
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50,
                                validation: {
                                    min: 5,
                                    max: 100,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "alt",
                                type: "number",
                                label: "ALT (U/L)",
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50,
                                validation: {
                                    min: 1,
                                    max: 4000,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "platelet_count",
                                type: "number",
                                label: "Platelet Count (thou/μL)",    
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },                            
                                width: 50,
                                validation: {
                                    min: 10000,
                                    max: 2000000 ,
                                    allowDecimal: true,
                                    decimalPlaces: 2
                                }
                            },
                            {
                                id: "fib4_score",
                                type: "calculated",
                                label: "FIB-4 Score (Calculated)",
                                formula: "(age * ast) / (platelet_count * Math.sqrt(alt))",
                                dependencies: ["age", "ast", "alt", "platelet_count"],
                                showIf: {
                                    field: "lab_report_available",
                                    value: "YES"
                                },
                                width: 50
                            }
                        ]
                    },
                    {
                        id: "medications",
                        title: "Prior & Concomitant Medications",
                        fields: [
                            {
                                id: "antihyperglycemic_table",
                                type: "table",
                                label: "Please record details of anti-hyperglycemics taken by the patient during the study visit.",
                                required: true,
                                columns: [
                                    {
                                        id: "PCMMDCS",
                                        type: "select",
                                        label: "Medication Class",
                                        required: true,
                                        options: [
                                            "Antihyperglycemic"
                                        ]
                                    },
                                    {
                                        id: "PCMNAME",
                                        type: "text",
                                        label: "Medication Name",
                                        required: true
                                    },
                                    {
                                        id: "PCMDOSE",
                                        type: "number",
                                        label: "Dose",
                                        width: 100,
                                        required: true
                                    },
                                    {
                                        id: "PCMUNIT",
                                        type: "select",
                                        label: "Unit",
                                        required: true,
                                        width: 100,
                                        options: ["g", "mg", "µg", "ml", "U", "IU"]
                                    },
                                    {
                                        id: "PCMDFM",
                                        type: "select",
                                        label: "Dosage Form",
                                        required: true,
                                        options: ["Tablet", "Capsule", "Syrup", "Injection", "Powder", "Others"]
                                    },
                                    {
                                        id: "PCMFREQ",
                                        type: "select",
                                        label: "Frequency",
                                        required: true,
                                        width: 70,
                                        options: ["OD", "BD", "TID", "QID", "PRN", "Others"]
                                    },
                                    {
                                        id: "pc4start_date",
                                        label: "Start Date",
                                        type: "date",
                                        width: 130
                                    },
                                    {
                                        id: "pc4stop_date",
                                        label: "Stop Date",
                                        width: 130,
                                        type: "date"
                                    },
                                    {
                                        id: "pc4ongoing",
                                        label: "Ongoing",
                                        width: 80,
                                        type: "checkbox"
                                    },
                                    {
                                        id: "PC4MDUR",
                                        type: "text",
                                        label: "Duration",    
                                        disabled: true
                                    }
                                ]
                            },
                            {
                                id: "has_concomitant_meds",
                                type: "radio",
                                label: "Has the patient taken any concomitant medications (along with anti-hyperglycemics) since the last 28 days or is taking during the study visit? (For e.g., Antihypertensive, Lipid lowering, Antiplatelets, Heart Failure medication, Anti-obesity or OTC medications, vitamins, herbal remedies, etc. as per relevance)",
                                options: ["YES", "NO"],
                                required: true,
                                boldLabel: true
                            },
                            {
                                id: "medication_table",
                                type: "table",
                                label: "",
                                showIf: {
                                    field: "has_concomitant_meds",
                                    value: "YES"
                                },
                                required: true,
                                columns: [
                                    {
                                        id: "PCMMDCS",
                                        type: "select",
                                        label: "Medication Class",
                                        required: true,
                                        options: [
                                            "Antihypertensive",
                                            "Lipid lowering",
                                            "Antiplatelets",
                                            "Heart Failure medication",
                                            "Antiobesity",
                                            "Others"
                                        ]
                                    },
                                    {
                                        id: "PCMMDCS_OTHER",
                                        type: "text",
                                        label: "Specify Medication Class",
                                        required: true,
                                        showIf: {
                                            field: "PCMMDCS",
                                            value: "Others"
                                        }
                                    },
                                    {
                                        id: "PCMNAME",
                                        type: "text",
                                        label: "Medication Name",
                                        required: true
                                    },
                                    {
                                        id: "PCMDOSE",
                                        type: "number",
                                        label: "Dose",
                                        width: 100,
                                        required: true
                                    },
                                    {
                                        id: "PCMUNIT",
                                        type: "select",
                                        label: "Unit",
                                        required: true,
                                        width: 100,
                                        options: ["g", "mg", "µg", "ml", "U", "IU"]
                                    },
                                    {
                                        id: "PCMDFM",
                                        type: "select",
                                        label: "Dosage Form",
                                        required: true,
                                        options: ["Tablet", "Capsule", "Syrup", "Injection", "Powder", "Others"]
                                    },
                                    {
                                        id: "PCMFREQ",
                                        type: "select",
                                        label: "Frequency",
                                        required: true,
                                        width: 70,
                                        options: ["OD", "BD", "TID", "QID", "PRN", "Others"]
                                    },
                                    {
                                        id: "pc5start_date",
                                        label: "Start Date",
                                        type: "date",
                                        width: 130,
                                        required: true
                                    },
                                    {
                                        id: "pc5stop_date",
                                        label: "Stop Date",
                                        width: 130,
                                        type: "date"
                                    },
                                    {
                                        id: "pc5ongoing",
                                        label: "Ongoing",
                                        width: 80,
                                        type: "checkbox"
                                    },
                                    {
                                        id: "PC5MDUR",
                                        type: "text",
                                        label: "Duration",
                                        disabled: true
                                    }
                                ]
                            },
                            {
                                id: "concomitant_meds_comments",
                                type: "textarea",
                                label: "Comments",
                                width: 100,
                                placeholder: "Enter any additional comments"
                            }
                        ]
                    }
                ]
            },
            {
                id: "section_5_declaration",
                order: 5,
                title: "Section 5: Investigator Declaration",
                subsections: [
                    {
                        id: "investigator_declaration",
                        title: "Declaration",
                        description: "I have reviewed the data entries for all pages in this Case Report Form. To the best of my knowledge, they are complete, accurate and compatible with the source documents. All entries were either made by myself or a person under my supervision who has signed the Delegation Log.",
                        fields: [
                            {
                                id: "investigator_signature",
                                type: "signature",
                                label: "Signature",
                                required: true
                            }
                        ]
                    }
                ]
            }
        ]
    }
};

export const getStudyFormById = (studyId) => {
    const id = String(studyId);
    return STUDY_FORMS[id] || null;
};

export { STUDY_FORMS };
